module.exports = __webpack_public_path__ + "static/20-4403b9b6de32bb84b03a84fd97042b24.jpg";